module.exports = __webpack_public_path__ + "static/media/full_conversation.91c5901b.svg";